import React from 'react';

import SearchIcon from '@assets/Icons/SearchLg';
import ClearIcon from '@assets/Icons/XCircle';

import styles from './styles.module.scss';

export type SearchHandler = (value: string) => void;

export interface ISearchFilter {
  placeholder?: string;
  searchHandler: SearchHandler;
  value: string;
  onClearHandler: () => void;
}

const SearchFilter = ({ placeholder, searchHandler, value, onClearHandler }: ISearchFilter) => {
  return (
    <div className={styles.container}>
      <SearchIcon size={20} />
      <input
        value={value}
        onChange={(e) => searchHandler(e.target.value)}
        className="text-input text-input--compressed"
        placeholder={placeholder}
        type="text"
      />
      {value !== '' && (
        <button type="button" className={styles.clear} onClick={onClearHandler}>
          <ClearIcon size={20} />
        </button>
      )}
    </div>
  );
};

export default SearchFilter;
